import React from 'react'

export const CraftEditor = React.lazy(() => import('./CraftEditor'))

export * from './CraftEditorTypes'
